const titles = {
  login: { domain: 'account', key: 'login.title' },
  forgotPassword: { domain: 'account', key: 'forgot-password.title' },
  forgotPasswordChange: {
    domain: 'account',
    key: 'forgot-password-change.title',
  },
  personalization: { domain: 'account', key: 'personalization.headline' },
  trackingSettings: { domain: 'tracking-settings', key: 'page.title' },
  settings: { domain: 'account', key: 'settings.title' },
};

export default ({ routeName }, { t }) => {
  return {
    title: titles[routeName]
      ? `${t(titles[routeName].domain, titles[routeName].key)} | ${t(
          'meta',
          'site.name'
        )}`
      : t('meta', 'landing.title'),
  };
};
